export const stringToBoolean = (value: string): boolean =>
  String(value) === "true";

export const stringIsBoolean = (value: string): boolean =>
  value === "true" || value === "false";

export const stringToList = (item: string): any => (item !== "" ? [item] : []);

export const excerpt = (text: string, limit: number, sufix = "..."): string => {
  if (text.length < limit) return text;

  return `${text.substring(0, limit)}${sufix}`;
};

export const removeAccents = (text: string): string =>
  text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const removeSpecialChars = (text: string): string =>
  text.replace(/[^\w\s]/gi, "");

export const removeSpaces = (text: string): string => text.replace(/\s/g, "");

export const stringToCPF = (text: string): string =>
  text.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

export const stringToCNPJ = (text: string): string =>
  text.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$3");

export const extractNumbers = (text: any): string => text.replace(/\D/g, "");

export const findJsonStart = (text: string): number => text.indexOf("{");

export const extractJsonString = (text: string, jsonStart: number): string =>
  text.substring(jsonStart);

export const parseJsonString = (jsonString: string): any | null => {
  try {
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
};

export const extractJsonFromText = (text: string): any | null => {
  const jsonStart = findJsonStart(text);
  if (jsonStart !== -1) {
    const jsonString = extractJsonString(text, jsonStart);
    return parseJsonString(jsonString);
  }
  return null;
};

export const addEllipsis = (text: string, limit: number): string => {
  if (text.length > limit) return `${text.substring(0, limit)}...`;

  return text;
};
